import React, { useState } from "react";

const Contact = () => {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const form = e.target;
    const data = new FormData(form);

    // Netlify Forms submission via fetch (same origin)
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(data).toString(),
    })
      .then(() => {
        setSent(true);
        setLoading(false);
        form.reset();
        setTimeout(() => setSent(false), 5000);
      })
      .catch(() => {
        setError("Something went wrong. Please try again.");
        setLoading(false);
      });
  };

  return (
    <section className="section">
      <div className="container narrow">
        <h1 className="section-title">Contact Us</h1>
        <p className="section-intro">
          If you&apos;d like to collaborate, explore how Wellness Minds could support your
          team, or simply ask a question, send us a message below. We&apos;ll respond as
          soon as we can.
        </p>

        <form
          className="contact-form"
          onSubmit={handleSubmit}
          name="contact"
          data-netlify="true"
          netlify-honeypot="bot-field"
        >
          {/* Required for Netlify: form name */}
          <input type="hidden" name="form-name" value="contact" />

          {/* Honeypot field for bots */}
          <p style={{ display: "none" }}>
            <label>
              Don’t fill this out: <input name="bot-field" />
            </label>
          </p>

          <div className="form-row">
            <label htmlFor="name">Name</label>
            <input
              id="name"
              name="name"
              type="text"
              placeholder="Your name"
              required
            />
          </div>

          <div className="form-row">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder="you@example.com"
              required
            />
          </div>

          <div className="form-row">
            <label htmlFor="subject">Subject</label>
            <input
              id="subject"
              name="subject"
              type="text"
              placeholder="What would you like to talk about?"
              required
            />
          </div>

          <div className="form-row">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows="4"
              placeholder="Share a few lines about what you’re looking for."
              required
            ></textarea>
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Sending..." : "Send message"}
          </button>

          {sent && (
            <p
              id="success-msg"
              style={{
                marginTop: "12px",
                color: "#2f8f9d",
                fontWeight: 600,
              }}
            >
              ✅ Thank you! Your message has been sent successfully.
            </p>
          )}

          {error && (
            <p style={{ marginTop: "8px", color: "crimson", fontSize: "0.85rem" }}>
              {error}
            </p>
          )}
        </form>

        <div className="contact-extra">
          <p>
            You can also reach us directly at{" "}
            <a href="mailto:support@wellnessminds.in">support@wellnessminds.in</a> or on
            WhatsApp at +91 8217617245.
          </p>
          <p>
            For emergencies, thoughts of self-harm or immediate risk to yourself or
            others, please contact your local emergency number or a licensed mental health
            professional. Wellness Minds does not provide crisis support.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
